import React, { useEffect, useMemo, useState } from 'react';
import { TableComponent, SortingColumnsType } from '../../../../../../components/table-component/table';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import './../verification.scss';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid, TextField } from '@mui/material';

import { FormValidation } from '../../../../../../core/utility';
// importing admin dashboard and local services
import { AdminDashboardService } from '../../../../../../core/services/admin-dashboard.service';
import { LocalService } from '../../../../../../core/services';
// important common popup component
import CommonPopUp from '../../../../../../components/popup/common-popup';

// To connect to redux
import { Loading } from '../../../../../../redux/action';
import { connect, useDispatch } from 'react-redux';
import { AdminPageHead } from '../../components/AdminPageHead';
// old code: import { Editor } from '../../../../../../components'; -> used by CampaignDetailPopup now
import { MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
// common campaign details popup (view + edit) shared with the platform > campaign details screen
import { CampaignDetailPopup } from '../../components/campaign-detail-popup';

// Create an instances of AdminDashboardServices, LocalServices and formValidations
const adminDashboardService = new AdminDashboardService();
const localService = new LocalService();
const formValidation = new FormValidation();

const dateFormat = 'YYYY-MM-DD';

const columnDisplayName = {
  brand_name: 'Brand Name',
  full_name: 'Campaign Owner',
  login_email: 'Owner Email',
  login_mobile: 'Owner Phone',
  campaign_title: 'Campaign Name',
  campaign_visibility: 'Campaign Visibility',
  posted_at: 'Submitted On',
  action: 'Action',
}

const sortingColumnType: SortingColumnsType[] = [
  {
    name: 'brand_name',
    columnSize: '180px',
  },
  {
    name: 'full_name',
    columnSize: '180px',
  },
  {
    name: 'login_email',
    columnSize: '180px',
  },
  {
    name: 'login_mobile',
    columnSize: '180px',
  },
  {
    name: 'campaign_title',
    columnSize: '180px',
  },
  {
    name: 'campaign_visibility',
    columnSize: '180px',
  },
  {
    name: 'posted_at',
    columnSize: '180px',
  },
  {
    name: 'action',
    columnSize: '320px',
  },
]

interface Props {
  loading: (data: any) => any;
  userData: any;
}

const CampaignVerification: React.FC<Props> = (props: Props) => {

  const [renderData, setRenderData] = useState<any>([])

  // Review campaign data
  const [reviewCampaignData, setReviewCampaignData] = useState<any>([]);

  // Search / date filter form data
  const [searchFormData, setSearchFormData] = useState({
    name: '',
    start_date: '',
    end_date: '',
  });
  const [appliedFilters, setAppliedFilters] = useState({
    name: '',
    start_date: '',
    end_date: '',
  });
  const [dateError, setDateError] = useState('');

  // Modal form data
  const [formData, setFormData] = useState({
    reviewed_by: props.userData.user_id,
    remark: '',
    campaign_id: '',
    status: '',
    campaign_title: '',
    campaign_visibility: '',
    campaign_owner: '',
    posted_at: '',
  });

  // Set form error fields
  const [formError, setFormErrors] = useState({
    remark: { status: true, message: '' },
    campaign_title: { status: true, message: "" },
    campaign_description: { status: true, message: "" },
    brand_description: { status: true, message: "" },
    brand_web_url: { status: true, message: "" },
    budget: { status: true, message: "" },
    comments: { status: true, message: "" },
  });

  const handleError = (event: any) => {
    // Validate form
    // validating name
    const validateRemark = formValidation.GetNameValidate(formData.remark);
    setFormErrors({
      ...formError,
      remark: validateRemark,
    });
  };

  // set Modal variables and usestate
  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const handleOpenModal = () => setOpenModal(true);
  function handleCloseModal() {
    setOpenModal(false);
    setFormData({
      ...formData,
      remark: '',
      campaign_id: '',
      status: '',
      campaign_title: '',
      campaign_visibility: '',
      campaign_owner: '',
      posted_at: '',
    });
  }

  const [reviewed_campaign, setCampaignReviewed] = useState(false);
  const [campaignDetail, setCampaignDetail] = useState<any>([]);
  const [openCampaignModal, setOpenCampaignModal] = useState(false);

  /* old code: the edit form state now lives inside the common CampaignDetailPopup component
  const [performEditCancel, setPerformEditCancel] = useState(false);

  const [campaignFormData, setCampaignFormData] = useState({
    campaign_id: campaignDetail[0]?.campaign_id,
    campaign_title: campaignDetail[0]?.campaign_title,
    campaign_description: campaignDetail[0]?.campaign_description,
    proposal_dt: campaignDetail[0]?.proposal_dt,
    go_live_dt: campaignDetail[0]?.go_live_dt,
    brand_description: campaignDetail[0]?.brand_description,
    brand_web_url: campaignDetail[0]?.brand_web_url,
    influencer_gender: campaignDetail[0]?.influencer_gender,
    budget: campaignDetail[0]?.budget,
    comments: campaignDetail[0]?.comments
  });
  */

  const navigate = useNavigate();
  const handleButtonClick = (event: any, buttonId: any) => {
    switch (buttonId) {
      case 'publishButton':
        // setCampaignStatus('Live');
        setCampaignReviewed(false)
        setModalTitle('Please Confirm');
        setModalContent(
          `Click 'Live' to post the campaign '${event.target.dataset.campaign_title}', created By advertiser: ${event.target.dataset.campaign_owner}.`
        );
        setFormData({
          ...formData,
          reviewed_by: props.userData.user_id,
          campaign_id: event.target.dataset.campaign_id,
          status: 'Live',
        });
        break;
      case 'rejectButton':
        // setCampaignStatus('Rejected');
        setCampaignReviewed(false)
        setModalTitle('Please Confirm');
        setModalContent(
          `Click 'Reject' to reject the campaign '${event.target.dataset.campaign_title}', created By advertiser: ${event.target.dataset.campaign_owner}.`
        );
        setFormData({
          ...formData,
          reviewed_by: props.userData.user_id,
          campaign_id: event.target.dataset.campaign_id,
          status: 'Rejected',
        });
        break;
      default:
        setCampaignReviewed(true)
        setModalTitle('Reviewed Campaign Details');
        setModalContent('')
        const dataset = event.target.dataset;
        setFormData({
          ...formData,
          reviewed_by: dataset.reviewed_by,
          campaign_id: dataset.campaign_id,
          status: dataset.status,
          remark: dataset.remark,
          campaign_title: dataset.campaign_title,
          campaign_visibility: dataset.campaign_visibility,
          campaign_owner: dataset.campaign_owner,
          posted_at: dataset.posted_at,
        });
    }
    // Open the modal
    handleOpenModal();
  };
  // end of modal

  // Submit form logic
  const handleConfirmation = async (e: any) => {
    try {
      e.preventDefault();
      // Validate form
      // validating name
      const validateRemark = formValidation.GetNameValidate(formData.remark);
      setFormErrors({
        ...formError,
        remark: validateRemark,
      });
      if (validateRemark.status) {
        try {
          const response = await adminDashboardService.updateReviewCampaigns(
            formData
          );
          if (response.data.status) {
            localService.toastify(response.data.message, 'success', 1000);
            getReviewCampaignsData();
          } else {
            localService.toastify(response.data.message, 'error', 1000);
          }
        } catch (error) {
          console.log(
            'Update Review Campaign Error :: ',
            JSON.stringify(error)
          );
        }
        // Close the modal after handling form submission
        setOpenModal(false);
      }
    } catch (error) {
      console.log('Update Review Campaign Error :: ', JSON.stringify(error));
      // Close the modal after handling form submission
      setOpenModal(false);
    }
  };

  // Separate function to get review campaigns to call it multiple times on form submit;
  async function getReviewCampaignsData() {
    try {
      props.loading(true);
      const res = await adminDashboardService.getReviewCampaigns();
      setReviewCampaignData(res?.data?.rows || []);
    } catch (error) {
      console.error('Error fetching campaigns:', error);
      setReviewCampaignData([]);
    } finally {
      props.loading(false);
    }
  }

  useEffect(() => {
    getReviewCampaignsData();
  }, []);

  const handleSearch = () => {
    if (!searchFormData.name.trim() && !searchFormData.start_date && !searchFormData.end_date) {
      setDateError('Please enter a brand/owner/email/phone or select a date range to search');
      return;
    }
    if (searchFormData.start_date && !searchFormData.end_date) {
      setDateError('Please enter end date');
      return;
    }
    if (!searchFormData.start_date && searchFormData.end_date) {
      setDateError('Please enter start date');
      return;
    }
    if (searchFormData.start_date && searchFormData.end_date && searchFormData.start_date > searchFormData.end_date) {
      setDateError('Start date should be less than end date');
      return;
    }
    setDateError('');
    setAppliedFilters(searchFormData);
  };

  const hasActiveFilters = Boolean(
    searchFormData.name || searchFormData.start_date || searchFormData.end_date
  );

  const handleClear = () => {
    const resetFilters = { name: '', start_date: '', end_date: '' };
    setSearchFormData(resetFilters);
    setAppliedFilters(resetFilters);
    setDateError('');
  };

  const filteredReviewCampaignData = useMemo(() => {
    const { name, start_date, end_date } = appliedFilters;
    const search = name.trim().toLowerCase();
    return (reviewCampaignData || []).filter((row: any) => {
      const matchesSearch =
        !search ||
        [row.brand_name, row.full_name, row.login_email, row.login_mobile].some(
          (field: any) => field && String(field).toLowerCase().includes(search)
        );
      const rowDate = row.posted_at ? dayjs(row.posted_at) : null;
      const matchesStartDate = !start_date || (rowDate && !rowDate.isBefore(dayjs(start_date), 'day'));
      const matchesEndDate = !end_date || (rowDate && !rowDate.isAfter(dayjs(end_date), 'day'));
      return matchesSearch && matchesStartDate && matchesEndDate;
    });
  }, [reviewCampaignData, appliedFilters]);

  async function getToCampaign(campaignId: number) {
    try {
      const res = await adminDashboardService.getCampaignDetail(campaignId);
      if (res.status) {
        setCampaignDetail([res.data[0]])
        setOpenCampaignModal(true)
        // navigate('/campaign-detail', { state: { campaignDetail: res.data[0] } });
      } else {
        // navigate(`/brand/orders/confirmed?payment_id=${payment_id}&campaign_id=${props.campaignReducer.createCampaign.campaign_id}`);
      }
    } catch (error) {
      console.error('Error fetching campaigns:', error);
      setCampaignDetail([]);
      setOpenCampaignModal(false)
    } finally {
    }
  }

  function handleCloseCampaignDetailModal() {
    setOpenCampaignModal(false);
    // old code: setPerformEditCancel(false) -> the edit/cancel state is handled by CampaignDetailPopup now
  }

  // old code: the save handler and the form hydration now live inside the common CampaignDetailPopup component
  // const handleCampaignDetailFormData = async (e: React.FormEvent) => {
  // e.preventDefault();
  // props.loading(true);
  // try {
  // const isValidCampaignTitle = formValidation.GetNameValidate(campaignFormData?.campaign_title);
  // const isValidCampaignDescription = formValidation.getdescriptionIsValid(campaignFormData.campaign_description);
  // let isValidBrandWebUrl = { status: true, message: '' };
  //
  // if (campaignFormData.brand_web_url && campaignFormData.brand_web_url.trim().length) {
  // isValidBrandWebUrl = formValidation.CheckIsValidURL(campaignFormData.brand_web_url);
  // setFormErrors((prevData) => ({
  // ...prevData,
  // brand_web_url: isValidBrandWebUrl,
  // }));
  // }
  //
  // // validating budget: it should be a positive number (budget column is an INT)
  // let isValidBudget = { status: true, message: '' };
  // const budgetValue = `${campaignFormData.budget ?? ''}`.trim();
  // if (budgetValue.length === 0 || !/^\d+$/.test(budgetValue)) {
  // isValidBudget = { status: false, message: 'Please enter a valid budget (numbers only)' };
  // }
  //
  // // validating comments: comments column allows max 1024 characters
  // let isValidComments = { status: true, message: '' };
  // const commentsValue = `${campaignFormData.comments ?? ''}`;
  // if (commentsValue.length > 1024) {
  // isValidComments = { status: false, message: 'Comments cannot exceed 1024 characters' };
  // }
  //
  // /* old code
  // setFormErrors((prevData) => ({
  // ...prevData,
  // campaign_title: isValidCampaignTitle,
  // campaign_description: isValidCampaignDescription,
  // }));
  // */
  // setFormErrors((prevData) => ({
  // ...prevData,
  // campaign_title: isValidCampaignTitle,
  // campaign_description: isValidCampaignDescription,
  // budget: isValidBudget,
  // comments: isValidComments,
  // }));
  //
  // // old code: if (isValidCampaignTitle.status && isValidCampaignDescription.status && isValidBrandWebUrl.status) {
  // if (isValidCampaignTitle.status && isValidCampaignDescription.status && isValidBrandWebUrl.status && isValidBudget.status && isValidComments.status) {
  // const res = await adminDashboardService.updateCampaignDetail(campaignFormData);
  // if (res.data.status) {
  // localService.toastify("Campaign updated successfully", 'success', 1000);
  // setOpenCampaignModal(false)
  // setPerformEditCancel(false)
  // getReviewCampaignsData();
  // } else {
  // localService.toastify(res.data.message, 'error', 1000);
  // setOpenCampaignModal(false)
  // setPerformEditCancel(false)
  // }
  // }
  // } catch (error) {
  // localService.toastify('An error occurred while updating campaign detail.', 'error', 1000);
  // console.error(`Error updating campaign detail: ${error}`);
  // } finally {
  // props.loading(false);
  // }
  // };
  //
  // useEffect(() => {
  // if (campaignDetail?.length > 0) {
  // setCampaignFormData((prevState) => ({
  // ...prevState,
  // campaign_id: campaignDetail[0]?.campaign_id,
  // campaign_title: campaignDetail[0]?.campaign_title,
  // campaign_description: campaignDetail[0]?.campaign_description,
  // proposal_dt: campaignDetail[0]?.proposal_dt,
  // go_live_dt: campaignDetail[0]?.go_live_dt,
  // brand_description: campaignDetail[0]?.brand_description,
  // brand_web_url: campaignDetail[0]?.brand_web_url,
  // // added influencer gender, budget and comments to make them editable from admin dashboard
  // influencer_gender: campaignDetail[0]?.influencer_gender,
  // budget: campaignDetail[0]?.budget,
  // comments: campaignDetail[0]?.comments
  // }));
  // }
  // }, [campaignDetail,openCampaignModal,performEditCancel]);


  return (
    <div className='campaign-verification-main'>
      {openModal && (
        <CommonPopUp
          modalTitle={modalTitle}
          modalContent={modalContent}
          openModal={openModal}
          onClose={() => handleCloseModal()}
          className="modal-medium mx-auto"
        >
          {reviewed_campaign
            ?
            (
              <div>
                <ul>
                  <li><strong>Campaign Status: </strong>{formData.status}</li>
                  <li><strong>Campaign Title: </strong>{formData.campaign_title}</li>
                  <li><strong>Campaign Visibility: </strong>{formData.campaign_visibility}</li>
                  <li><strong>Campaign Created By: </strong>{formData.campaign_owner}</li>
                  <li><strong>Reviewed By: </strong>{formData.reviewed_by}</li>
                  <li><strong>Published On: </strong>{formData.posted_at ? dayjs(formData.posted_at).format('LL') : ''}</li>
                  <li><strong>Remarks: </strong>{formData.remark}</li>
                </ul>
              </div>
            )
            :
            (<form onSubmit={handleConfirmation}>
              <TextField
                fullWidth
                label='Remark'
                name='remark'
                variant='standard'
                value={formData?.remark}
                error={!formError?.remark?.status}
                helperText={formError?.remark?.message}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    remark: e.target.value,
                  })
                }
                onBlur={handleError}
              />
              <div className='col-lg-auto text-end mt-3'>
                <Button
                  size='small'
                  type='submit'
                  variant='outlined'
                  className={
                    formData.status == 'Live'
                      ? 'btn btn-outline-primary'
                      : 'btn btn-outline-error'
                  }
                >
                  {formData.status === 'Rejected' ? 'Reject' : 'Live'}
                </Button>
              </div>
            </form>)
          }
        </CommonPopUp>
      )}
      <AdminPageHead title="Verifications" subtitle="Review campaigns before they go live." />
      {dateError.length > 0 && <span className="error">{dateError}</span>}
      <div className='verification-search-form'>
        <form onSubmit={(e) => { e.preventDefault(); handleSearch(); }}>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={1} rowSpacing={1}>
              <Grid item xs={12} sm={6} lg={4}>
                <div className='formInputDiv'>
                  <label htmlFor=''>Brand/Owner/Email/Phone</label>
                  <TextField
                    style={{ fontSize: '14px' }}
                    size='small'
                    value={searchFormData.name}
                    onChange={(e: any) =>
                      setSearchFormData({
                        ...searchFormData,
                        name: e.target.value,
                      })
                    }
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={5} lg={3}>
                <div className='formInputDiv'>
                  <label htmlFor=''>From</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['StartDate']}>
                      <MobileDatePicker
                        className='w-100'
                        format='DD-MM-YYYY'
                        maxDate={dayjs(new Date())}
                        value={searchFormData.start_date ? dayjs(searchFormData.start_date) : null}
                        onChange={(e: any) =>
                          setSearchFormData({
                            ...searchFormData,
                            start_date: e ? e.format(dateFormat) : '',
                          })
                        }
                        slotProps={{
                          textField: { size: 'small' },
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
              </Grid>
              <Grid item xs={12} sm={5} lg={3}>
                <div className='formInputDiv'>
                  <label htmlFor=''>To</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['EndDate']}>
                      <MobileDatePicker
                        className='w-100'
                        format='DD-MM-YYYY'
                        maxDate={dayjs(new Date())}
                        value={searchFormData.end_date ? dayjs(searchFormData.end_date) : null}
                        onChange={(e: any) =>
                          setSearchFormData({
                            ...searchFormData,
                            end_date: e ? e.format(dateFormat) : '',
                          })
                        }
                        slotProps={{
                          textField: { size: 'small' },
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
              </Grid>
              <Grid item xs={12} sm={2} lg={2}>
                <div style={{ marginTop: '20px', display: 'flex', gap: '8px' }}>
                  <Button
                    type='submit'
                    className='btn btn-primary btn-mui'
                  >
                    Search
                  </Button>
                  {hasActiveFilters && (
                    <Button
                      type='button'
                      className='btn btn-outline-primary btn-mui'
                      onClick={() => handleClear()}
                    >
                      Clear
                    </Button>
                  )}
                </div>
              </Grid>
            </Grid>
          </Box>
        </form>
      </div>
      <TableComponent
        pagination={true}
        columnDisplayName={columnDisplayName}
        inputDataSource={filteredReviewCampaignData}
        orderByColumnName='influencer_name'
        sortingColumnType={sortingColumnType}
        renderData={renderData}
        setRenderData={e => setRenderData(e)}>
        {
          renderData.map((data: any, index: number) => {
            return (
              <TableRow key={index} hover role='checkbox'>
                <TableCell>{data.brand_name}</TableCell>
                <TableCell>{data.full_name}</TableCell>
                <TableCell>{data.login_email}</TableCell>
                <TableCell>{data.login_mobile}</TableCell>
                <TableCell><a href="javascript:void(0);" onClick={() => getToCampaign(data.campaign_id)}>{data.campaign_title}</a></TableCell>
                <TableCell>{data.campaign_visibility}</TableCell>
                <TableCell>{data.posted_at ? dayjs(data.posted_at).format('LL') : ''}</TableCell>
                <TableCell>
                  <div className='d-flex'>
                    {
                      (data.remark != '' && data.status != 'Under Review')
                        ?
                        <div>
                          <Button
                            className='btn btn-primary btn-sm'
                            data-campaign_id={data.campaign_id}
                            data-campaign_owner={data.login_email}
                            data-campaign_title={data.campaign_title}
                            data-campaign_visibility={data.campaign_visibility}
                            data-remark={data.remark}
                            data-posted_at={data.posted_at}
                            data-status={data.status}
                            data-reviewed_by={data.reviewed_by}
                            onClick={(e) =>
                              handleButtonClick(e, 'statusButton')
                            }
                          >
                            {`${data.status === 'Rejected' ? 'Rejected' : 'Posted'} on: ` + (data.posted_at ? dayjs(data.posted_at).format('LL') : '')}
                          </Button>
                        </div>
                        :
                        <div>
                          <Button
                            className='btn btn-primary btn-sm'
                            data-campaign_id={data.campaign_id}
                            data-campaign_owner={data.login_email}
                            data-campaign_title={data.campaign_title}
                            data-campaign_visibility={data.campaign_visibility}
                            onClick={(e) =>
                              handleButtonClick(e, 'publishButton')
                            }
                          >
                            Publish
                          </Button>
                          <Button
                            className='btn btn-outline-error btn-sm'
                            style={{ marginLeft: '10px' }}
                            data-campaign_id={data.campaign_id}
                            data-campaign_owner={data.login_email}
                            data-campaign_title={data.campaign_title}
                            data-campaign_visibility={data.campaign_visibility}
                            onClick={(e) =>
                              handleButtonClick(e, 'rejectButton')
                            }
                          >
                            Reject
                          </Button>
                        </div>
                    }
                  </div>
                </TableCell>
              </TableRow>
            )
          })
        }
      </TableComponent>


      {/* the campaign details popup is now a common component (components/campaign-detail-popup.tsx)
          so that the platform > campaign details screen can reuse the same view + edit ability */}
      <CampaignDetailPopup
        openModal={openCampaignModal}
        campaignDetail={campaignDetail}
        onClose={() => handleCloseCampaignDetailModal()}
        onUpdated={() => getReviewCampaignsData()}
      />

    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    userData: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(CampaignVerification);
export { connectToRedux as CampaignVerification };
